module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/smiley-7656e782bd04f4ee8bac6ee46e8c15be.svg";